<template>
  <div>
    <!-- begin row -->
    <div class="row row-space-2">
      <!-- begin col-12 -->
      <div class="col-lg-12">
        <div
          class="widget-chart with-sidebar"
          :class="{ 'inverse-mode': inverseMode }"
        >
          <div
            class="widget-chart-content"
            :class="{ 'bg-black': inverseMode }"
          >
            <h4
              class="chart-title ts-flex ts-justify-between"
              :class="{ 'text-grey': !inverseMode }"
            >
              <strong> {{ $t('dashboardcomponents.studentStatus') }}</strong>
              <select
                class="filter"
                :class="{ 'filter-dark': inverseMode }"
                v-model="selectedFilter"
                @change="fetchData"
              >
                <option
                  v-for="(filter, filterKey) in filters"
                  :value="filterKey"
                  :key="filterKey"
                >
                  {{ filter }}
                </option>
              </select>
            </h4>
            <ts-loading-banner :loading="loading">
              <div
                class="widget-chart-full-width ts-px-4"
                :class="{ 'nvd3-inverse-mode': inverseMode }"
              >
                <p>
                  {{
                    $t(
                      'dashboardcomponents.barchartsshowthestatisticsofthestudentsbasedontheselectedcategoryUsercouldseetheactualdataofstatusticsbyputamousepointeroveranybarusercouldalsoseethesameactualstatisticsatthecyclechartattherightsidebyselectinganycategory'
                    )
                  }}
                </p>
                <bar-chart
                  :data="{
                    labels: labels,
                    datasets: datasets
                  }"
                  :options="options"
                  class="height-sm"
                ></bar-chart>
              </div>
            </ts-loading-banner>
          </div>
          <div class="widget-chart-sidebar bg-black-darker">
            <ts-loading-banner :loading="loading">
              <span v-if="oldNewItem">
                <div v-for="(i, key) in oldNewItem" :key="key">
                  <div class="chart-number">
                    {{ totalStudent(i) }}
                    <small>{{ $t('dashboardcomponents.totalStudents') }}</small>
                  </div>
                  <div class="nvd3-inverse-mode" style="height: 180px">
                    <vn-pie
                      :model="[
                        {
                          label: 'Old',
                          value: i.Old,
                          color: '#348fe2'
                        },
                        {
                          label: 'New',
                          value: i.New,
                          color: '#00ACAC'
                        }
                      ]"
                      :donut="donut"
                      text-field="label"
                      value-field="value"
                      :show-tooltip-percent="true"
                      :show-legend="false"
                    ></vn-pie>
                    <ul class="pager m-t-0 m-b-0">
                      <li
                        v-tooltip="'Previous'"
                        class="previous"
                        :class="{ disabled: current_page <= 0 }"
                      >
                        <a href="#" @click.prevent="prevPage"
                          ><i class="fas fa-angle-left"></i
                        ></a>
                      </li>
                      <li>
                        <a href="#">{{ className }}</a>
                      </li>
                      <li
                        v-tooltip="'Next'"
                        class="next"
                        :class="{ disabled: current_page >= totalPage }"
                      >
                        <a href="#" @click.prevent="nextPage"
                          ><i class="fas fa-angle-right"></i
                        ></a>
                      </li>
                    </ul>
                    <ul class="chart-legend f-s-11">
                      <li>
                        <i
                          class="fa fa-circle fa-fw text-success f-s-9 m-r-5 t-minus-1"
                        ></i>
                        {{ percentagesNew(i) }}%
                        <span>{{ $t('dashboardcomponents.newStudents') }}</span>
                      </li>
                      <li>
                        <i
                          class="fa fa-circle fa-fw text-primary f-s-9 m-r-5 t-minus-1"
                        ></i>
                        {{ percentagesOld(i) }}%
                        <span>{{ $t('dashboardcomponents.oldStudents') }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </span>
            </ts-loading-banner>
          </div>
        </div>
      </div>
      <!-- end col-12 -->
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import BarChart from '@/components/vue-chartjs/BarChart'
import { keys, map } from 'lodash'

export default {
  components: {
    BarChart
  },
  props: ['inverseMode'],
  data() {
    return {
      filters: {
        class_name: 'Class',
        grade_name_foreign: 'Grade',
        level_abbr: 'Level',
        acps_abbr: 'Sub Progam',
        term_name: 'Term',
        acp_abbr: 'Academic Progam',
        ac_year: 'Academic Year'
      },
      loading: false,
      selectedFilter: '',

      // BarChart student status
      studentStatus: [],
      status: ['Active', 'Droped out', 'Suspend', 'Terminated'],
      borderColor: ['#00acac', '#ff5b57', '#fd7e14', '#6610f2'],
      backgroundColor: [
        'rgba(0, 172, 172, 0.5)',
        'rgba(255, 91, 87, 0.5)',
        'rgba(253, 126, 20, 0.5)',
        'rgba(102, 16, 242, 0.5)'
      ],
      options: {
        responsive: true,
        maintainAspectRatio: false
      },
      // Donut Chart student old/new
      donut: true,
      data: [],
      studentOldNews: [],
      oldNewItem: '',
      current_page: 0,
      className: ''
    }
  },
  computed: {
    // bar chart
    labels() {
      return keys(this.studentStatus)
    },
    datasets() {
      return this.status.map((s, index) => {
        return {
          label: s,
          borderColor: this.borderColor[index],
          backgroundColor: this.backgroundColor[index],
          borderWidth: 1,
          data: map(this.studentStatus, r => {
            return r[s]
          })
        }
      })
    },
    // donut chart
    classes() {
      return keys(this.studentOldNews)
    },
    totalPage() {
      if (keys(this.studentOldNews)) {
        return keys(this.studentOldNews).length - 1
      }
      return 0
    }
  },
  mounted() {
    this.selectedFilter = Object.keys(this.filters)[0]

    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('dashboard/fetchStudentStatus', {
          group_by: this.selectedFilter
        })
        .then(responses => {
          this.studentStatus = responses.studentStatus
          this.studentOldNews = responses.studentOldNew
          this.loading = false
          this.prevPage()
        })
        .catch(() => {
          this.loading = false
        })
    },
    prevPage() {
      if (this.current_page > 0) {
        this.current_page--
        return this.changePage(this.classes[this.current_page])
      }
      return this.changePage(this.classes[this.current_page])
    },

    nextPage() {
      if (this.current_page < this.totalPage) {
        this.current_page++
        this.changePage(this.classes[this.current_page])
      }
    },
    changePage(classKey) {
      if (classKey) {
        this.className = classKey
        this.oldNewItem = { classKey: this.studentOldNews[classKey] }
      }
    },
    totalStudent(item) {
      if (item) {
        return item.New + item.Old
      }
      return 0
    },
    percentagesNew(item) {
      if (item) {
        return ((item.New / (item.New + item.Old)) * 100).toFixed(2)
      }
      return 0
    },
    percentagesOld(item) {
      if (item) {
        return ((item.Old / (item.New + item.Old)) * 100).toFixed(2)
      }
      return 0
    }
  }
}
</script>
<style scoped>
.filter {
  color: #707478;
  border: 1px solid #d3d8de;
  -webkit-box-shadow: none;
  box-shadow: none;
  height: 35px;
  padding: 0.3125rem 0.625rem;
  font-size: 0.75rem;
  line-height: 1.4;
  border-radius: 3px;
}
.filter-dark {
  background-color: #242a30;
  color: white;
  border: 1px solid #1a1e22;
}
.text-gray {
  color: #585a5e;
}
.pager li > a,
.pager li > span {
  font-size: 0.7rem;
  padding: 2px 4px;
  border-radius: 15px;
}
</style>
